export const REAL_TIME = 'REAL_TIME';
